/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */

import Vue from 'vue';

/* ============
 * Plugins
 * ============
 *
 * Import and bootstrap the plugins.
 */


import './plugins/axios';
import { router } from './plugins/vue-router';
import './plugins/vuex';
import './plugins/vuex-router-sync';

/* ============
 * Styling
 * ============
 *
 * Import the application styling.
 * Sass is used for this project
 *
 * https://sass-lang.com/
 *
 */

import './assets/scss/main.scss';

/* ============
 * Main App
 * ============
 *
 * Last but not least, we import the main application.
 */

import App from './App';
import store from './store';

Vue.config.productionTip = false;

store.dispatch('auth/check');

/* eslint-disable no-new */
new Vue({
  /**
   * Bind the Vue instance to the HTML.
   */
  el: '#app',

  /**
   * The Vuex store.
   */
  store,

  /**
   * The router.
   */
  router,
  /**
   * Will render the application.
   *
   * @param {Function} h Will create an element.
   */
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js